import { Link } from "@/lib/router-compat";
import { ArrowRight, Check } from "lucide-react";
import { labelStyles, type Tool } from "@/data/tools";

const ToolCard = ({ tool }: { tool: Tool }) => {
  const Inner = (
    <div className="p-6 rounded-xl border border-border bg-card hover:border-primary/50 transition-all duration-300 flex flex-col h-full">
      <div className="flex items-center gap-4 mb-4">
        <div className="p-3 rounded-lg bg-primary/10">
          <tool.icon className="h-6 w-6 text-primary" />
        </div>
        <div className="flex-1">
          <div className="flex items-center gap-2 flex-wrap">
            <h3 className="text-xl font-bold text-foreground">{tool.title}</h3>
            {tool.label && (
              <span
                className={`px-2 py-0.5 text-xs font-medium rounded ${
                  labelStyles[tool.label] ?? "bg-primary/20 text-primary"
                }`}
              >
                {tool.label}
              </span>
            )}
          </div>
        </div>
      </div>
      <p className="text-muted-foreground mb-4 text-sm">{tool.description}</p>
      <ul className="space-y-2 mb-6">
        {tool.features.map((feature) => (
          <li key={feature} className="flex items-center gap-2 text-sm text-muted-foreground">
            <Check className="h-4 w-4 text-primary flex-shrink-0" aria-hidden="true" />
            <span>{feature}</span>
          </li>
        ))}
      </ul>
      <span className="mt-auto inline-flex items-center justify-center w-full gap-2 px-4 py-3 rounded-lg border border-border bg-card text-sm font-medium text-foreground group-hover:bg-muted transition-colors">
        Launch Tool
        <ArrowRight className="h-4 w-4" />
      </span>
    </div>
  );

  return tool.external ? (
    <a href={tool.href} target="_blank" rel="noopener noreferrer" className="group">
      {Inner}
    </a>
  ) : (
    <Link to={tool.href} className="group">
      {Inner}
    </Link>
  );
};

export default ToolCard;